import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Skeleton } from "@filadd/phi-plus-core";
import { css } from "@filadd/phi-plus-styled-system/css";
import { Circle } from "@filadd/phi-plus-styled-system/jsx";
import { DateTime } from "luxon";
import { Action } from "./Action";
import { NotificationIcon } from "./NotificationIcon";
const containerStyle = css({
    p: 2,
    borderRadius: "sm",
    display: "grid",
    gap: 2,
    gridTemplateAreas: '"icon description description"\n"icon date action"',
    gridTemplateColumns: "auto 1fr",
    justifyItems: "start",
    _hover: { bg: "primary.100" },
});
const iconContainerStyle = css({ gridArea: "icon" });
const iconStyle = css({
    display: "flex",
    rounded: "full",
    padding: 1,
    background: "neutral.100",
});
const descriptionStyle = css({
    gridArea: "description",
    color: "neutral.500",
    fontWeight: "medium",
    textStyle: "bodySmall",
});
const dateStyle = css({
    gridArea: "date",
    textStyle: "bodySmall",
    color: "neutral.300",
    fontWeight: "medium",
    alignSelf: "center",
});
export const Notification = ({ source, body, action, seen, created_at: createdAt, onSeen, onActed, }) => {
    const createdAtDateTime = DateTime.fromISO(createdAt, { zone: "utc" });
    return (_jsxs("div", { className: containerStyle, onMouseEnter: () => {
            if (action == null && !seen) {
                onSeen();
            }
        }, children: [_jsx("div", { className: iconContainerStyle, children: _jsx("div", { className: iconStyle, children: _jsx(NotificationIcon, { source: source, seen: seen }) }) }), _jsx("div", { className: descriptionStyle, children: body }), _jsx("div", { className: dateStyle, title: createdAtDateTime.toLocaleString(DateTime.DATETIME_FULL), children: createdAtDateTime.toRelative() }), action != null ? (_jsx("div", { className: css({ gridArea: "action", justifySelf: "end" }), children: _jsx(Action, { label: action.label, url: action.url, onActed: onActed }) })) : null] }));
};
const NotificationSkeleton = () => (_jsxs("div", { className: containerStyle, children: [_jsx("div", { className: iconContainerStyle, children: _jsx(Skeleton, { className: iconStyle, children: _jsx(Circle, { size: "6" }) }) }), _jsx("div", { className: descriptionStyle, children: _jsx(Skeleton, { children: "This is a placeholder for the description." }) }), _jsx("div", { className: dateStyle, children: _jsx(Skeleton, { children: "placeholder" }) })] }));
Notification.Skeleton = NotificationSkeleton;
//# sourceMappingURL=Notification.js.map